import type { Updaters } from '~/adapter/indexedDB/types'
import type { OfflineDownloadInfoSchemaV7 } from '../../7/downloadInfo/downloadInfo'
import type { EmployeeSchemaV7 } from '../../7/employee/employee'
import type { FeatureFlagSchemaV7 } from '../../7/featureFlag/featureFlag'
import type {
  MultipleChoiceSetSchemaV7,
  TemplateMultipleChoiceSetRelationSchemaV7,
} from '../../7/multipleChoiceSet/multipleChoiceSet'
import type {
  ReportManualSchemaV7,
  ReportNodeSchemaV7,
  ReportSchemaV7,
} from '../../7/report/report'
import type { ScheduleItemSchemaV7 } from '../../7/schedule/scheduleItem'
import type {
  TemplateNodeSchemaV7,
  TemplateSchemaV7,
} from '../../7/template/template'
import type { TemplateMediaSchemaV7 } from '../../7/template/templateMedia'
import type { VersionSchemaV7 } from '../../7/version/version'
import type { OfflineDownloadInfoSchemaV8 } from '../downloadInfo/downloadInfo'
import type { EmployeeSchemaV8 } from '../employee/employee'
import type { FeatureFlagSchemaV8 } from '../featureFlag/featureFlag'
import type {
  MultipleChoiceSetSchemaV8,
  TemplateMultipleChoiceSetRelationSchemaV8,
} from '../multipleChoiceSet/multipleChoiceSet'
import type {
  ReportManualSchemaV8,
  ReportNodeSchemaV8,
  ReportSchemaV8,
} from '../report/report'
import type { ScheduleItemSchemaV8 } from '../schedule/scheduleItem'
import type {
  TemplateNodeSchemaV8,
  TemplateSchemaV8,
} from '../template/template'
import type { TemplateMediaSchemaV8 } from '../template/templateMedia'
import type { VersionSchemaV8 } from '../version/version'

const version = 8
type versionType = typeof version

// V8: 質問ノードの union に時間計測（TimeMeasurementQuestionNodeV8）を追加するだけの
// 型拡張であり、既存の永続データに変換は不要（V7 以前のデータに時間計測は存在しない）。
// version テーブルのみインクリメントする。
export const migration: Pick<
  Updaters[versionType],
  'upgradeBefore' | 'migrations'
> = {
  upgradeBefore: async () => {},
  migrations: {
    versions: (prev: VersionSchemaV7): VersionSchemaV8 => {
      return {
        ...prev,
        version,
      }
    },
    featureFlags: (prev: FeatureFlagSchemaV7): FeatureFlagSchemaV8 => {
      return prev
    },
    reports: (prev: ReportSchemaV7): ReportSchemaV8 => {
      return prev
    },
    reportNodes: (prev: ReportNodeSchemaV7): ReportNodeSchemaV8 => {
      return prev
    },
    reportManuals: (prev: ReportManualSchemaV7): ReportManualSchemaV8 => {
      return prev
    },
    employees: (prev: EmployeeSchemaV7): EmployeeSchemaV8 => {
      return prev
    },
    offlineDownloadInfos: (
      prev: OfflineDownloadInfoSchemaV7,
    ): OfflineDownloadInfoSchemaV8 => {
      return prev
    },
    scheduleItems: (prev: ScheduleItemSchemaV7): ScheduleItemSchemaV8 => {
      return prev
    },
    templates: (prev: TemplateSchemaV7): TemplateSchemaV8 => {
      return prev
    },
    templateNodes: (prev: TemplateNodeSchemaV7): TemplateNodeSchemaV8 => {
      return prev
    },
    templateMedia: (prev: TemplateMediaSchemaV7): TemplateMediaSchemaV8 => {
      return prev
    },
    multipleChoiceSets: (
      prev: MultipleChoiceSetSchemaV7,
    ): MultipleChoiceSetSchemaV8 => {
      return prev
    },
    templateMultipleChoiceSetRelations: (
      prev: TemplateMultipleChoiceSetRelationSchemaV7,
    ): TemplateMultipleChoiceSetRelationSchemaV8 => {
      return prev
    },
  },
}
